<div style="flex: 1" *ngIf="props.visible">
<mat-form-field style="width: 100%">
  <mat-select [disabled]="!this.enabled" [hidden]="!this.visible" [(ngModel)]="selected" (ngModelChange)="onSelect($event)">
    <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
  </mat-select>
</mat-form-field>


</div>
<!--<pre>{{dataAsString}}</pre>-->